import React from 'react';
import {Button} from 'antd-mobile';
import {useTranslation} from 'react-i18next';
import {goWhatsAppChat} from '@/utils';

const TeamEmptyState: React.FC = () => {
  const {t} = useTranslation();

  const handleContact = () => {
    // 使用goWhatsAppChat函数联系客服，这里不传参数会使用默认逻辑
    goWhatsAppChat();
  };

  return (
    <div className="flex flex-col items-center justify-center py-5 px-4 w-full bg-white">
      {/* 空状态图片 */}
      <div className="mb-3">
        <img
          src={require('@/components/assets/imgs/empty.webp')}
          alt="Empty state"
          className="w-32 h-32 object-contain"
        />
      </div>

      {/* 提示文本 */}
      <div className="text-center mb-3">
        <p className="text-sm text-t2 leading-relaxed whitespace-pre-line">
          {t('proxy.new-user.error')}
        </p>
      </div>

      {/* Contact now按钮 */}
      <Button
        color="primary"
        className="bg-c1 text-white rounded-full px-5 py-2 [&_span]:text-sm"
        onClick={handleContact}>
        {t('proxy.user.contact')}
      </Button>
    </div>
  );
};

export default TeamEmptyState;
